import { render, staticRenderFns } from "./DdsPayment.vue?vue&type=template&id=42d8d82d&"
import script from "./DdsPayment.vue?vue&type=script&lang=js&"
export * from "./DdsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports